module.exports = __webpack_public_path__ + "img/checkApps.2f0a5627.svg";